
var user_switch = $('#userswitch_select');

if(user_switch.length !== 0) { //user switch is present on this page
  user_switch.change(function(event) { //on change, redirect to initiate login
    var target = $(event.currentTarget || event.target);
    if(target.data('changeUrl')) {
      jQuery(this).parent().find('.select2-search-field input').first().hide();
      window.location = target.data('changeUrl') + target.val();
    } else {
      bq.debug.error("no data-change-url detected on dom element", this);
    }
  });

  if(user_switch.data('ajaxUrl')) { //make sure ajaxUrl is available
                       
    user_switch.select2({
        minimumInputLength: 0,
        placeholder: 'Search',
        allowClear: true,
        maximumSelectionSize: 1,
        multiple: true,
        ajax: {
            url: user_switch.data('ajaxUrl'),
            dataType: 'json',
            data: function(term, page) {
                return {
                    search: term
                };
            },
            results: function (data, page) {
                return { results: data };
            }
        },
        escapeMarkup: function(m) {
            return m;
        }
    });

    user_switch.on('select2-open', function () {
        jQuery('.select2-search-field input').attr('placeholder', user_switch.attr('data-placeholder'))
    });

    user_switch.on('select2-close', function() {
        jQuery('.select2-search-field input').attr('placeholder', '');
        jQuery('.select2-search-field input').blur();
    });

  } else {
    bq.debug.error("no data-ajax-url detected on dom element", this);
  }

}